
import { Col, Tabs, Input, Layout, Row, Progress, Divider, Collapse } from "antd";

import React, { useState, useRef, useEffect } from "react";

import {RightOutlined, InfoCircleOutlined} from '@ant-design/icons'
import HeaderApp from "../header-app";
import Footer from "../../component/common/Footer";
import type { CollapseProps } from 'antd';


const FAQ = () => {

    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: <span className="text-white weight-400">What participation benefits are available to Guardian Node operators?</span>,
            children: <>
                <p className="mt-0 text-white">By running a HeLa Guardian Node, you directly contribute to the ecosystem by enhancing network security and supporting its growth. HeLa node owners will receive token rewards, including airdrops during listing events, and enjoy additional benefits from future collaborations with HeLa and its partners.</p>
            </>,
        },
        {
            key: '2',
            label: <span className="text-white weight-400">How do I get started and how can I set up my node?</span>,
            children: <>
                <p className="mt-0 text-white">Follow this guide for a step-by-step guide to help you get started: </p>
            </>,
        },
        {
            key: '3',
            label: <span className="text-white weight-400">Where can I buy Node?</span>,
            children: <>
                <p className="mt-0 text-white">You can buy a HeLa Guardian Node through the HeLa Labs node sales page. Check it here: <a target="_blank" href="https://guardian.helalabs.com/">https://guardian.helalabs.com/</a></p>
            </>,
        },
        
        {
            key: '5',
            label: <span className="text-white weight-400">What unique features does the HeLa node offer compared to others?</span>,
            children: <>
                <ul className="text-white mt-0">
                    <li><strong>First Mover Advantage:</strong> Earn a part of HeLa's total supply.</li>
                    <li><strong>NFT License:</strong> Get an NFT for node ownership.</li>
                    <li><strong>Extra Earnings:</strong> Stake NFTs to earn tokens from partnered projects.</li>
                    <li><strong>One Node for All:</strong> Exclusive platform for staking future NFTs.</li>
                    <li><strong>Earn & Stake:</strong> Get more HeLa tokens for rewards or convert to stablecoins.</li>
                    <li><strong>Potential Airdrop Incentives:</strong> Potentially earn fees from future NFTs staked on the nodes.</li>
                </ul>
            </>,
        },
        {
            key: '6',
            label: <span className="text-white weight-400">Are node incentives guaranteed?</span>,
            children: <>
                <p className="mt-0 text-white">No. Node incentives are not guaranteed. Any applicable incentives depend on factors such as network activity, node eligibility, uptime, task completion, technical performance, and the applicable programme terms.</p>
            </>,
        },
        {
            key: '7',
            label: <span className="text-white weight-400">What ecosystem participation benefits can Guardian Node operators receive?</span>,
            children: <>
                <p className="text-white mt-0">
                    Guardian Node participants may be eligible for ecosystem benefits linked to node operation, network support, uptime, task completion, and other participation requirements. Any incentives are subject to the applicable Guardian Node terms, network rules, eligibility requirements, and programme conditions.
                   
                </p>
            </>,
        },
    ];

    const itemsPricing: CollapseProps['items'] = [
        {
            key: '1',
            label: <span className="text-white weight-400">1. What is the initial price for a HeLa node?</span>,
            children: <>
                <p className="mt-0 text-white">The initial price is 330 HLUSD.</p>
            </>,
        },
        {
            key: '2',
            label: <span className="text-white weight-400">2. How many Guardian Nodes are available in each tier?</span>,
            children: <>
                <p className="mt-0 text-white">There are 2,500 Guardian Nodes available in each tier.</p>
            </>,
        },
        {
            key: '3',
            label: <span className="text-white weight-400">3. What is the total number of Guardian Nodes available for sale?</span>,
            children: <>
                <p className="mt-0 text-white">A total of 50,000 Guardian Nodes are available for sale across 20 tiers.</p>
            </>,
        },
        {
            key: '4',
            label: <span className="text-white weight-400">4. Through which network will the node sale be conducted?</span>,
            children: <>
                <p className="mt-0 text-white">The sale will be conducted on HeLa network via a public sale. You will be able to use USDT/USDC/HLUSD on HeLa network to purchase the nodes. Currently, as of November 2024, we support HLUSD only. </p>
            </>,
        },
        {
            key: '5',
            label: <span className="text-white weight-400">5. Can you buy fractions of a node?</span>,
            children: <>
                <p className="mt-0 text-white">No, nodes will be sold in whole units only.</p>
            </>,
        },
        {
            key: '6',
            label: <span className="text-white weight-400">6. When can nodes be transferred after purchase?</span>,
            children: <>
                <p className="mt-0 text-white">Nodes can be transferred only after all the 50,000 nodes have been fully sold. </p>
            </>,
        },
        {
            key: '7',
            label: <span className="text-white weight-400">7. What is the difference per each tier? </span>,
            children: <>
                <p className="mt-0 text-white">Each tier has a different price and potential return. </p>
            </>,
        },
        {
            key: '8',
            label: <span className="text-white weight-400">8. What will I receive alongside the node-related token allocation / participation incentive?</span>,
            children: <>
                <p className="mt-0 text-white">You will receive a total of 864 HeLa tokens per node vested over a period of 4 years. Besides HeLa tokens, node owners are on the priority list to receive perks from all partnerships and campaigns within the HeLa ecosystem.</p>
            </>,
        },
        {
            key: '9',
            label: <span className="text-white weight-400">9. What is the initial price of the Guardian Nodes?</span>,
            children: <>
                <p className="mt-0 text-white">The price is 330 HLUSD, equivalent to 330 USD (given that 1 HLUSD = 1 USDT/USDC). </p>
            </>,
        },
        {
            key: '10',
            label: <span className="text-white weight-400">10. How many token rewards does each node receive?</span>,
            children: <>
                <p className="mt-0 text-white">Each node receives 864 HeLa tokens rewards, vested over a period of 4 years.</p>
            </>,
        },
        
    ];

    const itemsReferral: CollapseProps['items'] = [
        {
            key: '1',
            label: <span className="text-white weight-400">1. How and when will referral rewards be processed?</span>,
            children: <>
                <p className="mt-0 text-white">Eligible referral rewards will be reviewed and processed approximately two weeks after the relevant sale has been completed and verified.<br />Referral rewards are subject to programme terms, successful verification, and completion of any required KYC, AML, sanctions, or eligibility checks. Participation in the referral programme does not grant any right to HELA token rewards, node incentives, revenue share, yield, or investment returns</p>
            </>,
        },
        {
            key: '2',
            label: <span className="text-white weight-400">2. What if I want to refer a larger community?</span>,
            children: <>
                <p className="mt-0 text-white">Users with an established community, audience, or partner network may apply for the Partner Referral Programme.<br />Approved partners may be eligible to receive a separate referral support fee or promotional credit for verified introductions, subject to the applicable partner terms, eligibility checks, and programme approval.<br />The Partner Referral Programme is a marketing and community growth programme only. It is separate from Guardian Node operation, HELA token utility, node incentives, staking, and any network participation rewards.</p>
            </>,
        },
        {
            key: '3',
            label: <span className="text-white weight-400">3. Where do I apply for the Partner Referral Scheme?</span>,
            children: <>
                <p className="mt-0 text-white">You may apply for the Partner Referral Programme using this link: <strong>Apply here</strong>.<br />Applicants will generally be required to provide:<br />Telegram ID;<br />email address;<br />proof of community or social media presence;<br />relevant audience or community information;<br />any other information required for verification and eligibility review.<br />Approval is not guaranteed and remains subject to HeLa&rsquo;s review, programme terms, compliance checks, and applicable restrictions.</p>
            </>,
        },
        
    ];
    
  
    return (
        <>
            <div className="app-page">
                <HeaderApp />
                <div className="container">
                    <div className="faq-page">
                        <div className="text-center font-25 weight-500 text-white mb-15">FAQs about HeLa Node Sale</div>
                        <Divider className="mb-0 text-center" orientation="left"><div className="text-lightblue font-20 weight-500 text-center">Why participate as a HeLa Guardian Node operator?</div></Divider>
                        <Collapse items={items} expandIcon={({ isActive }) => ''} bordered={false}/>

                        <Divider className="mb-0 text-center" orientation="left"><div className="text-lightblue font-20 weight-500 text-center">Node Sale Pricing</div></Divider>
                        <Collapse items={itemsPricing} expandIcon={({ isActive }) => ''} bordered={false}/>

                        <Divider className="mb-0 text-center" orientation="left"><div className="text-lightblue font-20 weight-500 text-center">Referral</div></Divider>
                        <Collapse items={itemsReferral} expandIcon={({ isActive }) => ''} bordered={false}/>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};
export default FAQ;
